export const SYNC_SUPPORTING_DOCUMENTS = 'SYNC_SUPPORTING_DOCUMENTS';
export const SYNC_SUPPORTING_DOCUMENTS_SUCCESS = 'SYNC_SUPPORTING_DOCUMENTS_SUCCESS';
export const SYNC_SUPPORTING_DOCUMENTS_ERROR = 'SYNC_SUPPORTING_DOCUMENTS_ERROR';
